const en = {
  nav: {
    howItWorks: "How it works",
    fees: "Fees",
    corridors: "Corridors",
    security: "Security",
    press: "Press",
    faq: "FAQ",
    contact: "Contact",
    joinWaitlist: "Join waitlist",
    joinWaitlistLong: "Join the waitlist",
    openMenu: "Open menu",
    language: "Language",
  },
  hero: {
    eyebrow: "Now boarding · Waitlist open",
    tag: "v1.0 — private beta launching in select corridors",
    line1: "Send money",
    line2: "instantly.",
    line3: "Africa \u2194 world.",
    subhead:
      "Instantxfer CashApp moves money between Africa and the rest of the world in minutes — with the lowest fees, live mid-market rates, and payout to bank, mobile money, cash pickup or a scan-to-pay handle.",
    ctaWaitlist: "Get early access",
    ctaHow: "See how a transfer works",
    trust: {
      settleLabel: "Median settlement",
      feeLabel: "Total transfer fee*",
      countriesLabel: "Countries at launch",
      feeNote: "*mid-market rate, no hidden FX margin",
      backedBy: "Backed by regulated payout partners in 34 markets",
    },
  },
  liveQuote: {
    eyebrow: "Live quote",
    liveMid: "live · mid-market",
    youSend: "You send",
    receive: "They receive",
    fee: "Fee",
    corridor: "Corridor",
    getRate: "Lock this rate",
  },
  corridors: {
    eyebrow: "Available corridors",
    headline: "Competitive exchange rates",
    headlineItalic: "on every transfer.",
    intro:
      "Instantxfer CashApp is currently available in these countries.",
    introHighlight: " More coming soon.",
    mostRequested: "Most requested",
    active: "Active",
    comingSoon: "Coming soon",
    activePill: "Active",
    soonPill: "Coming soon",
    votedPill: "Voted",
    tapToVote: "Tap a coming-soon country to vote it up",
    sentToday: "sent today",
    votes: "votes",
    notSeeing: "Not seeing a corridor you need?",
    requestIt: "Request it",
    requestTail: " — the most-voted corridors get built first.",
    footer: "Live rates · mid-market · 0.9% flat",
    you: "You",
  },
  waitlist: {
    eyebrow: "Get early access",
    title: "Reserve your handle,",
    italic: "lock lifetime fees.",
    body: "Instantxfer CashApp is rolling out one corridor at a time. Members of the Founder Circle get lifetime 0.5% pricing, priority payout limits, and first pick of scan-to-pay handles.",
    formTitle: "Join the private beta",
    email: "Email",
    emailPlaceholder: "you@company.com",
    fullName: "Full name (optional)",
    fullNamePlaceholder: "Your name",
    corridor: "Your main corridor",
    submit: "Reserve my spot",
    submitting: "Reserving…",
    already: "You're already on the list.",
    successTitle: "You're on the list.",
    successBody: "Check your inbox — we've just sent a confirmation with today's mid-market rates.",
    founderTitle: "You're a founder.",
    founderBody: "Check your inbox — a personal note from our founder is on its way with your lifetime perks.",
    error: "Something went wrong. Try again in a moment.",
    invalidEmail: "Please enter a valid email address.",
    privateBeta: "Private beta · Limited seats",
    skipQueue1: "Skip the queue",
    skipQueue2Italic: "in two fields.",
    membersLine: "Early members lock in lifetime lowest fees, priority payout limits, and first access to the scan-to-pay handle. No card required.",
    founderLive: "Founder 100 · Live",
    seatsTaken: "taken",
    seatsFillLive: "Seats fill in real time",
    seatsLeft: "left",
    referredBy: "Referred by",
    skipQueueTag: "· you skip the queue",
    quoteLabel: "Your quote:",
    quoteCta: "Save your spot to send it for real — we've pre-selected your corridor.",
    nudgeTitle: "Not sure where to start? Try the send calculator →",
    nudgeBody: "See live rates for your corridor, then come back to reserve your seat.",
    inviteLink: "Your invite link",
    bringFriend: "Bring a friend · one skip-the-queue pass",
    copy: "Copy",
    copied: "Copied",
    share: "Share",
    inviteFootnote: "Anyone who joins through your link jumps ahead. While seats remain, they become a founder too.",
    openFounderCircle: "Open Founder Circle",
    agreeTerms: "By joining you agree to our",
    and: "and",
    noSpam: ". No spam, ever.",
    terms: "terms",
    privacy: "privacy",
  },
  footer: {
    ctaEyebrow: "Ship money like a message",
    ctaTitle: "Africa & the world,",
    ctaTitleItalic: "two taps apart.",
    ctaBtn: "Get early access",
    colProduct: "Product",
    colCompany: "Company",
    colLegal: "Legal",
    colReach: "Reach",
    linkFounders: "Founder Circle",
    linkAbout: "About",
    linkPress: "Press & signal",
    terms: "Terms of service",
    privacy: "Privacy",
    amlKyc: "AML / KYC",
    cookies: "Cookies",
    systemsNominal: "Systems nominal",
    rights: "All rights reserved.",
    chatWhatsApp: "Chat with us on WhatsApp",
  },
  contact: {
    whatsApp: "WhatsApp",
    whatsAppNote: "Founders reply in under an hour · 09:00–20:00 WAT",
    chatWhatsApp: "Chat with us on WhatsApp",
  },
  foundersVideo: {
    eyebrow: "Meet the founder",
    title: "A 30-second hello",
    italic: "from Phil-Kholynes.",
    body: "Why we're building Instantxfer CashApp, who it's for, and the corridors we're switching on next. Straight from the founder.",
    comingSoon: "Video landing soon",
    duration: "0:30",
    playAria: "Play the founder introduction video",
  },
  launchToast: {
    eyebrow: "Corridor · Now Live",
    headline: "You asked. {{country}} is live.",
    body: "Mid-market rates, mobile money + bank rails — live from today across {{country}}.",
    cta: "Send your first transfer",
    dismiss: "Dismiss",
  },
  about: {
    seoTitle: "About · Four founders, one mission — Instantxfer CashApp",
    seoDescription: "Meet the four founders building the WhatsApp of cross-border money. Portraits, backstory, and the values printed on every receipt.",
    hero: {
      eyebrow: "The founders",
      title: "Four people",
      italic: "one photo book.",
      body: "We started Instantxfer CashApp because sending money home shouldn't feel like begging a bank. Meet the team behind the receipt.",
    },
    photobook: {
      eyebrow: "Portraits · The Founder Circle",
      title: "The people who signed",
      italic: "the manifesto.",
      body: "Every commitment in the manifesto is signed by these four. No board deck could replace that.",
      captionRole: "Role",
      captionCity: "City",
      captionSince: "With us since",
      share: "Share portrait",
      shareCopied: "Link copied",
    },
    timeline: {
      eyebrow: "Field notes · The founding story",
      title: "From an idea",
      italic: "to a thousand senders.",
      body: "Not a keynote. A chronological set of receipts, in the order they happened.",
      chapters: [
        {
          date: "Feb 2024",
          tag: "The idea",
          title: "Two bank transfers, one Sunday call.",
          body: "Phil-Kholynes sends school fees to Enugu on a Sunday. Three banks, forty-seven minutes, £34 gone. The next morning, a shared Notion doc titled 'instantxfer.md' has 14 bullet points and one manifesto line.",
        },
        {
          date: "Apr 2024",
          tag: "First prototype",
          title: "A calculator that told the truth.",
          body: "The team ships a static Send widget that quotes the mid-market rate — no spread, no wire markup. It's ugly. It's correct. That's the whole point.",
        },
        {
          date: "Aug 2024",
          tag: "First transfer",
          title: "£100 → ₦168,900, 42 seconds.",
          body: "The first live transfer lands in Adaeze's mother's GTBank account before her cup of tea finishes steeping. The receipt is printed on the fridge. It still is.",
        },
        {
          date: "Nov 2024",
          tag: "First hundred",
          title: "The Founder Circle opens.",
          body: "One hundred believers sign up in nine days. Every one of them gets a handwritten thank-you and a lifetime 0.5% seat. Their names live on the leaderboard, forever.",
        },
        {
          date: "Mar 2026",
          tag: "First thousand",
          title: "Corridors open across four continents.",
          body: "Seventeen active corridors. Live mid-market rates. Mobile money + bank + scan-to-pay handle. A thousand senders, moving money like a message. Canada joins the map.",
        },
        {
          date: "Now",
          tag: "The public rollout",
          title: "You, next.",
          body: "Private beta open, Founder 100 seats going fast. Every commitment on the manifesto still holds. The receipts keep printing.",
        },
      ],
    },
    manifestoNote: "Signed by all four, printed on every receipt.",
  },
  rateAlert: {
    eyebrow: "Rate alerts",
    headline: "Get pinged when",
    headlineItalic: "moves 1%",
    headlineTail: "in your favour.",
    body: "One email, only when the rate is meaningfully better. No spam, unsubscribe in one tap.",
    submit: "Notify me when it moves",
    sending: "Sending…",
    successTitle: "You're in.",
    alreadyTitle: "You're already on the list.",
    successBody: "We'll email {{email}} when {{from}} → {{to}} moves at least 1%.",
    errorRetry: "Please try again.",
    errorNet: "Network hiccup. Try again in a second.",
  },
  rateLock: {
    eyebrow: "Rate lock · 24h reward",
    headline: "Lock",
    headlineItalic: "today's rate",
    headlineTail: "for 24 hours.",
    body: "As a signup incentive, we'll honour today's mid-market rate for your first transfer — even if the market moves against us. One email, one lock, zero hidden fees.",
    submit: "Lock this rate",
    submitting: "Locking…",
    successTitle: "Rate locked.",
    alreadyTitle: "You already locked this rate.",
    lockedAt: "You locked",
    goodUntil: "Good until",
    finishSignup: "Finish your signup",
    errorRetry: "Please try again.",
    errorNet: "Network hiccup. Try again in a second.",
    countdown: "Lock expires in",
    share: "Share my lock",
    downloadCard: "Download card",
    days: "d",
    hours: "h",
    minutes: "m",
    seconds: "s",
    leaderboard_one: "{{count}} rate locked in the last 24h",
    leaderboard_other: "{{count}} rates locked in the last 24h",
  },
  cookies: {
    heading: "We use",
    headingItalic: "a few.",
    body: "We use a couple of cookies to remember you and improve the site. No ads, no third-party tracking.",
    acceptAll: "Accept all",
    onlyEssential: "Only essential",
    privacy: "Privacy policy",
  },
  common: {
    live: "Live",
    soon: "Soon",
    watchCorridor: "Watch this corridor",
    open: "Open corridor",
    close: "Close",
  },
  home: {
    trust: { eyebrow: "Wired into the rails", body: "Direct payout partnerships across every corridor — no correspondent banks in the middle." },
    send: { eyebrow: "Try it before you install", title: "The exact number,", italic: "before you tap send." },
    manifesto: { eyebrow: "The manifesto", headline: "Six commitments, printed on the receipt.", chaptersLabel: "Chapters", tag: "Written by hand · signed by all four founders", items: [
      { title: "Fees should fit on one line.", body: "0.9% flat. No wire spread. No hidden FX margin. What you send is what they receive — printed on the ticket before you tap." },
      { title: "Minutes, not business days.", body: "Direct rails into mobile money and bank networks across 34 countries. Most transfers settle in under three minutes." },
      { title: "One handle for everything.", body: "@philKholynes.instant works everywhere. Bank, wallet, cash pickup — or a scanned EMVCo QR at a corner shop in Kigali." },
      { title: "Family-first, not finance-first.", body: "Recurring support, split with siblings, pay a school directly, top up airtime — designed for the way remittance actually happens." },
      { title: "Regulated where it matters.", body: "Licensed money-service partners on both sides. KYC that respects your time — three fields, ninety seconds, one photo." },
      { title: "Built for the next billion.", body: "iOS-native performance, offline receipts, low-bandwidth mode, and support in nine languages including Yoruba, Swahili and Amharic." },
    ]},
    corridorMap: { eyebrow: "Corridors · 34 countries" },
    payout: { eyebrow: "Payout methods", title: "Land the money", italic: "the way life expects it." },
    handle: { eyebrow: "Scan · Send · Settle", title: "One handle.", italic: "Everywhere." },
    leaderboard: { eyebrow: "Founder leaderboard", title: "The first hundred", italic: "who believed in us." },
    comparison: { eyebrow: "The math", title: "What you save,", italic: "printed in green." },
    editorial: { eyebrow: "Field notes", title: "The remittance story", italic: "as we're rewriting it." },
    security: { eyebrow: "Security & compliance", title: "Built like a bank,", italic: "shaped like a message." },
    appStore: { eyebrow: "Coming Q2 2026", title: "iOS & Android,", italic: "on the same day." },
    qrInstall: { eyebrow: "Scan to install", title: "Point a phone.", italic: "Start sending.", subtitle: "Scan with your phone" },
  },
  pageHero: {
    howItWorks: {
      eyebrow: "How it works",
      title: "Send money like a text.",
      italic: "Arrives before your reply.",
      body: "Four steps, one tap. Instantxfer CashApp settles cross-border transfers between Africa and the world in minutes — with the lowest fees, live mid-market rates, and payout to bank, mobile money, cash pickup or a scan-to-pay handle.",
    },
    fees: {
      eyebrow: "Fees",
      title: "One flat 0.9%.",
      italic: "No hidden FX margin.",
      body: "We charge one honest fee — 0.9% of the transfer — on top of the real mid-market rate. Founder 100 members lock in 0.5% for life.",
    },
    countries: {
      eyebrow: "Corridors",
      title: "17 corridors live.",
      italic: "40 more coming soon.",
      body: "Instantxfer CashApp is currently available in these countries. Vote for the corridor you need — the most-requested ones get built first.",
    },
    security: {
      eyebrow: "Security",
      title: "Bank-grade security,",
      italic: "human-grade care.",
      body: "Regulated payout partners in 34 markets. Encrypted end-to-end. Multi-factor auth by default. Your money is held in segregated, ring-fenced accounts.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Everything you need",
      italic: "to trust us with your money.",
      body: "Short answers to the questions we hear most from founders, senders and press.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Say hello.",
      italic: "We reply within a day.",
      body: "Press, partnerships, questions from the road. Reach the founding team directly — no ticket queue, no bot.",
    },
    press: {
      eyebrow: "Press · signal room",
      title: "Everything a journalist",
      italic: "needs in under a minute.",
      body: "Founder bios, brand assets, weekly digest previews, and a direct line to the team.",
    },
    founders: {
      eyebrow: "Founder Circle",
      title: "The first hundred people",
      italic: "who believed in us.",
      body: "Founder 100 members lock in lifetime 0.5% pricing, priority payout limits, and first pick of scan-to-pay handles.",
    },
    waitlist: {
      eyebrow: "Get early access",
      title: "Reserve your handle,",
      italic: "lock lifetime fees.",
      body: "Instantxfer CashApp is rolling out one corridor at a time. Members of the Founder Circle get lifetime 0.5% pricing, priority payout limits, and first pick of scan-to-pay handles.",
    },
    terms: { eyebrow: "Legal", title: "Terms of service.", italic: "Plain English, mostly.", body: "The rules that govern your use of Instantxfer CashApp." },
    privacy: { eyebrow: "Legal", title: "Privacy notice.", italic: "Your data, your rules.", body: "What we collect, why, and how you can ask us to delete it." },
    aml: { eyebrow: "Compliance", title: "AML & KYC.", italic: "How we keep the network clean.", body: "The identity, source-of-funds and monitoring checks that keep the platform safe for everyone." },
    cookies: { eyebrow: "Legal", title: "Cookies.", italic: "The bare minimum.", body: "The essential cookies we use, and the analytics we run to learn what to build next." },
  },
  content: {
    howItWorks: {
      steps: [
        {
          title: "Verify in 90 seconds",
          body: "Snap a photo of your ID, take a selfie. Instantxfer CashApp's KYC engine confirms you're you — usually before your kettle boils.",
          detail: ["Passport, driver's licence or national ID", "Automatic liveness check", "Zero-knowledge biometric vault"],
        },
        {
          title: "Add your people",
          body: "Bank, wallet or handle — pick the rail that lands the fastest. Save recipients once, reuse forever with Face-ID.",
          detail: ["M-Pesa · MoMo · Orange · Airtel", "Bank via routing / IBAN / GT#", "@handle.instant across networks"],
        },
        {
          title: "Send with the exact number",
          body: "See the mid-market rate, the fee, and what they'll receive — to the cent — before you tap send. No spread, no surprise.",
          detail: ["Live mid-market FX", "0.9% flat, disclosed up-front", "Optional lock for 24 hours"],
        },
        {
          title: "Watch it land",
          body: "Median under three minutes to mobile money, banks or agent cash pickup. You'll get a receipt with a shareable link so they know it's on the way.",
          detail: ["Real-time payout tracking", "SMS + push confirmation", "24/7 human support in beta"],
        },
      ],
    },
    fees: {
      note: "Prices shown are illustrative. Founder Circle rates apply for the first year and require signup during the private beta.",
      tiers: [
        {
          name: "Personal",
          priceNote: "flat, per send",
          features: ["Up to $10,000 / month", "Bank + mobile money + QR", "Live mid-market FX", "24/7 support"],
          cta: "Join waitlist",
        },
        {
          name: "Founder Circle",
          priceNote: "for the first year",
          features: ["First 5,000 members only", "Priority payout up to $50k / month", "Direct line to founders", "Early access to scan-to-pay"],
          cta: "Reserve seat",
        },
        {
          name: "Business",
          priceNote: "custom pricing",
          features: ["Volume discounts from $50k / month", "Multi-user roles + audit log", "API + webhooks", "Named account manager"],
          cta: "Talk to sales",
        },
      ],
    },
    security: {
      controls: [
        { title: "Key-vaulted, device-bound", body: "Session tokens are bound to the physical device via Secure Enclave / StrongBox. Every payment is signed on-device before it leaves." },
        { title: "Zero-knowledge sync", body: "Your contacts and transfer history are encrypted with keys we can't read. If we leaked our database, an attacker would find noise." },
        { title: "3-D fraud engine", body: "Every send is scored on device, behaviour and network signals. Anomalies pause the send and trigger a human review — usually in seconds." },
        { title: "Audit trail on every rail", body: "Immutable, signed logs across all payout partners. Reconciliation runs continuously — not once a day at 4am." },
        { title: "Regulated, not renegade", body: "Instantxfer CashApp partners with licensed money-service businesses in each corridor. Funds are held in segregated safeguarding accounts at Tier-1 banks." },
        { title: "Coordinated disclosure", body: "Coordinated disclosure with a standing bounty. Security researchers welcome — security@instantxfer.com." },
      ],
    },
    faq: {
      items: [
        { q: "How fast is a transfer, really?", a: "Median settlement is under three minutes to mobile money and major banks in Nigeria, Kenya, Ghana, Uganda, Rwanda, Senegal, Côte d'Ivoire and South Africa. Bank transfers to smaller institutions can take up to 30 minutes depending on the destination network cutoffs." },
        { q: "What does Instantxfer CashApp actually cost me?", a: "0.9% of the send amount, calculated at mid-market. No spread, no wire fee, no monthly fee. Cash-pickup corridors carry a small agent fee ($1–$3) that we surface up-front." },
        { q: "Which mobile money networks do you support?", a: "M-Pesa (Kenya, Tanzania), MTN MoMo (Ghana, Nigeria, Uganda, Rwanda, Zambia, Côte d'Ivoire, Benin), Orange Money (Senegal, Côte d'Ivoire, Mali), Airtel Money (Uganda, Zambia, Malawi), Wave (Senegal, Côte d'Ivoire), Telebirr (Ethiopia), plus several regional wallets." },
        { q: "What's this scan-to-pay handle about?", a: "Your Instantxfer CashApp handle (@yourname.instant) is a portable payment identity. Print it, share it in a chat, or drop it on a merchant's EMVCo QR — money settles instantly, without cards or account numbers." },
        { q: "How do you make money if fees are that low?", a: "We settle in bulk on direct rails and take a small margin on the flow — never on the FX rate. As we scale, unit economics improve, and we pass that back to Founder Circle members." },
        { q: "Is my money safe?", a: "Funds are held in segregated safeguarding accounts at Tier-1 banks. Instantxfer CashApp partners with licensed money-service businesses in every corridor. Balances are covered up to the applicable regulatory limit in your jurisdiction." },
        { q: "What ID do I need for KYC?", a: "A photo of your passport, national ID or driver's licence, plus a quick selfie. Verification typically completes in under 90 seconds. Business accounts require corporate documents and beneficial-ownership disclosure." },
        { q: "Do you support crypto?", a: "Not at launch. We may add optional stablecoin rails for cross-corridor settlement — but consumer-facing product remains fiat, mobile money and bank transfer." },
        { q: "When is Instantxfer CashApp launching?", a: "Private beta ships to Founder Circle members first. Public rollout follows in select corridors — join the waitlist to get on the invite list." },
      ],
    },
  },
};

export default en;
